<template>
  <Popup
    :title="title"
    :visible="visible"
    :singleBtn="false"
    @popupCancle="handleCancel"
    @popupOk="handleOk"
  >
    <div
      id="myChart"
      :style="{ width: '500px', height: '500px' }"
      ref="echarts"
    ></div>
    <div class="tabTime">
      <div
        v-for="item in chartTab"
        :key="item.value"
        @click="checkTabBox(item)"
        :class="tabActive == item.key ? 'tabBox' : 'tabItem'"
      >
        {{ item.text }}
      </div>
    </div>
  </Popup>
</template>
<script>
import { getAction } from '@/api/manage';
import Popup from '@/components/common/Popup';
export default {
  name: 'LookKeyModal',
  components: {
    Popup,
  },
  data() {
    return {
      title: '操作',
      tabActive: 1,
      timePeriod: 'day',
      chartTab: [
        {
          key: 1,
          text: '近一天',
          value: 'day',
        },
        {
          key: 2,
          text: '近一周',
          value: 'week',
        },
        {
          key: 3,
          text: '近一月',
          value: 'month',
        },
        {
          key: 4,
          text: '近一年',
          value: 'year',
        },
      ],
      id: '',
      form: this.$form.createForm(this),
      width: 800,
      visible: false,
      isDisable: false,
      confirmLoading: false,
      url: {
        add: process.env.VUE_APP_CMS_WECHAT + '/wechatApp/add',
        edit: process.env.VUE_APP_CMS_WECHAT + '/wechatApp/edit',
      },
    };
  },
  mounted() {
    this.$nextTick(function () {});
  },
  methods: {
    add(id) {
      this.visible = true;
      if (id) {
        this.$nextTick(() => {
          this.drawLine(id);
          this.id = id;
        });
      }
    },
    close() {
      if (this.title == '新增') {
        this.$emit('close');
      }
      this.visible = false;
    },
    handleOk() {
      this.close();
    },
    handleCancel() {
      this.close();
    },
    checkTabBox(item) {
      this.timePeriod = item.value;
      this.tabActive = item.key;
      this.drawLine(this.id);
    },
    drawLine(id) {
      let timePeriod = this.timePeriod;
      let systemId = id;
      // let myChart = this.$echarts.init(document.getElementById('myChart'));
      let myechart = this.$echarts.init(this.$refs.echarts);

      getAction(
        process.env.VUE_APP_CMS_SYSTEM +
          `/sys/auth/call/statistics?systemId=${systemId}&timePeriod=${timePeriod}`
      ).then((res) => {
        if (res.success) {
          let dataX = [];
          let dataY = [];
          res.result.map((item) => {
            dataX.push(item.timeUnitValue);
            dataY.push(item.callNum);
          });

          console.warn(dataX, dataY);
          let option = {
            tooltip: {
              trigger: 'axis',
              backgroundColor: '#333333',
              extraCssText: 'width:240px;height:138px;',
              textStyle: {
                color: '#ffffff',
                fontSize: 14,
              },
              // position:['50%','20%']
            },
            xAxis: {
              type: 'category',
              data: dataX,
            },
            yAxis: {
              type: 'value',
              minInterval: 1,
            },
            series: [
              {
                data: dataY,
                type: 'line',
              },
            ],
          };
          this.$nextTick(() => {
            myechart.setOption(option);
          });
        } else {
          this.$message.error(res.message);
        }
      });
      // console.log(document.getElementById('myChart'));

      // option && myChart.setOption(option);
      // myChart.setOption = {
      //   title: {
      //     text: 'Stacked Line'
      //   },
      //   tooltip: {
      //     trigger: 'axis'
      //   },
      //   legend: {
      //     data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
      //   },
      //   grid: {
      //     left: '3%',
      //     right: '4%',
      //     bottom: '3%',
      //     containLabel: true
      //   },
      //   toolbox: {
      //     feature: {
      //       saveAsImage: {}
      //     }
      //   },
      //   xAxis: {
      //     type: 'category',
      //     boundaryGap: false,
      //     data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      //   },
      //   yAxis: {
      //     type: 'value'
      //   },
      //   series: [
      //     {
      //       name: 'Email',
      //       type: 'line',
      //       stack: 'Total',
      //       data: [120, 132, 101, 134, 90, 230, 210]
      //     },
      //     {
      //       name: 'Union Ads',
      //       type: 'line',
      //       stack: 'Total',
      //       data: [220, 182, 191, 234, 290, 330, 310]
      //     },
      //     {
      //       name: 'Video Ads',
      //       type: 'line',
      //       stack: 'Total',
      //       data: [150, 232, 201, 154, 190, 330, 410]
      //     },
      //     {
      //       name: 'Direct',
      //       type: 'line',
      //       stack: 'Total',
      //       data: [320, 332, 301, 334, 390, 330, 320]
      //     },
      //     {
      //       name: 'Search Engine',
      //       type: 'line',
      //       stack: 'Total',
      //       data: [820, 932, 901, 934, 1290, 1330, 1320]
      //     }
      //   ]
      // };
    },
  },
};
</script>
<style></style>
<style scoped lang="less">
/deep/.ant-modal-content .ant-modal-body {
  height: 600px;
}
/deep/ .ant-table {
  height: 70vh;
}

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
.tabTime {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  .tabItem {
    height: 32px;
    padding: 6px 19px;
    text-align: center;
    background: #eee;
    margin-right: 10px;
    color: #999999;
  }
}
.tabBox {
  height: 32px;
  padding: 6px 19px;
  text-align: center;
  margin-right: 10px;
  background: #004e98 !important;
  color: #ffffff;
}
</style>
